/* eslint-disable */
import React, { useCallback, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import QCXFinalFormDialog from '../../shared-components/dialog/QCXFinalFormDialog';
import QCXSelectDespesaReceitaAutocomplete from '../../shared-components/select-despesa-receita/QCXSelectDespesaReceitaAutocomplete';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import { CLOSED_STATUS, isOpenStatus } from '../../utils/hooks/form/dialog/formDialogUtils';

export default function QCXDuplicateDespesaDialogForm({
  openStatus,
  handleFormStatus,
  handleOnSubmit,
  initialValues,
  filterParams,
}) {
  const { t } = useTranslation();
  const open = isOpenStatus(openStatus);

  const handleClose = useCallback(() => {
    handleFormStatus(CLOSED_STATUS);
  }, [handleFormStatus]);

  const dialogInitialValues = useMemo(
    () => ({
      despesaReceita: { id: initialValues?.despesaReceita?.id },
      valorPagarMoeda: initialValues?.valorPagarMoeda,
    }),
    [initialValues]
  );

  return (
    <QCXFinalFormDialog
      key="form-dialog-duplicar-despesa"
      id="form-dialog-duplicar-despesa"
      title="Duplicar despesa"
      open={open}
      initialValues={dialogInitialValues}
      onSubmit={handleOnSubmit}
      onClose={handleClose}
      dialogActionsProps={{
        button: {
          submit: { description: 'Duplicar', size: 'small', color: 'secondary' },
          cancel: { description: t('com.muralis.qcx.acoes.cancelar'), size: 'small' },
        },
      }}
    >
      {({ values }) => (
        <>
          <Grid item xs={12} style={{ paddingTop: '0.5rem' }}>
            <QCXSelectDespesaReceitaAutocomplete
              id="dup-despesa-receita"
              name="despesaReceita.id"
              label={t('com.muralis.qcx.despesa.label')}
              initialValues={values}
              filterParams={filterParams}
              required
            />
          </Grid>

          <Grid item xs={12} style={{ paddingTop: '1rem' }}>
            <QCXFinalAlternativeCurrencyField
              id="dup-valor"
              name="valorPagarMoeda"
              label={t('com.muralis.qcx.valorSolicitado')}
              decimalPlaces={2}
              required
            />
          </Grid>
        </>
      )}
    </QCXFinalFormDialog>
  );
}